import { useState, useEffect } from 'react';
import { HostBackend } from '../../../../Routes/HostBackend.js';
import { GetHeaders } from '../../../../Components/Admin/Functions/FetchHeaders.js';
/* document */
import { Text } from '../../Form/Inputs/Text.js';
import { Select } from '../../Form/Inputs/Select.js';
import { Hidden } from '../../Form/Inputs/Hidden.js';

export const Family = (props) => {
    const backend = HostBackend();
    const token = sessionStorage.getItem('token');
    const [describeChooser, setDescribeChooser] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            const datasDescribe = await fetch(`${backend}/admin/collection/describe_family`, GetHeaders(token));
            const describeChooser = await datasDescribe.json();
            setDescribeChooser(describeChooser);
        };
        fetchData();
    }, [backend, token]);
    const name = (props.el) ? props.el.name : '';
    const slug = (props.el) ? props.el.slug : '';
    const route = (props.el) ? props.el.route : '';
    const id_description = (props.el) ? props.el.id_description : '';
    const id = (props.el) ? props.el.id : '';
    return (
        <>
            <Text name="name" value={name} />
            <Text name="slug" value={slug} />
            <Text name="route" value={route} />
            <Select name="id_description" choosers={describeChooser} value={id_description} />
            <Hidden name="id" value={id} />
        </>
    )
}